var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavBlocklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 811445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8034 22.5277C10.6432 22.5277 10.6432 22.5277 10.4829 22.5277C7.59909 22.5277 4.71525 22.5277 1.8314 22.5277C1.19054 22.5277 0.870117 22.2072 0.870117 21.5664C0.870117 19.003 1.51097 16.5998 2.9529 14.3568C4.07439 12.7546 5.3561 11.6331 6.95824 10.8321C6.95824 10.8321 7.11845 10.8321 7.11845 10.6718C5.3561 9.55035 4.55503 7.94821 4.39482 5.86543C4.39482 4.2633 5.03567 2.82137 6.15717 1.69987C8.56038 -0.543117 12.2453 -0.382904 14.3281 2.0203C16.5711 4.58372 16.0904 8.58907 13.0464 10.6718C13.8474 11.1525 14.6485 11.6331 15.2894 12.1138C13.0464 12.7546 11.284 14.0363 10.3227 16.1191C9.36145 18.3621 9.52166 20.4449 10.8034 22.5277Z",
    fill: "url(#paint0_linear_698_4835)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 811446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4348 23.7634C18.9394 23.7634 21.7805 20.9223 21.7805 17.4177C21.7805 13.9131 18.9394 11.072 15.4348 11.072C11.9302 11.072 9.08911 13.9131 9.08911 17.4177C9.08911 20.9223 11.9302 23.7634 15.4348 23.7634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4348 23.7634C18.9394 23.7634 21.7805 20.9223 21.7805 17.4177C21.7805 13.9131 18.9394 11.072 15.4348 11.072C11.9302 11.072 9.08911 13.9131 9.08911 17.4177C9.08911 20.9223 11.9302 23.7634 15.4348 23.7634Z",
    fill: "url(#paint1_linear_698_4835)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1302 17.4076C23.1302 21.6711 19.6882 25.1131 15.4249 25.1131C11.1615 25.1131 7.68045 21.6711 7.71956 17.4076C7.71956 13.1442 11.2006 9.70213 15.464 9.70213C19.6882 9.70213 23.1302 13.1833 23.1302 17.4076ZM10.8095 14.122C9.44055 15.7648 9.12764 19.0113 11.2398 21.2799C13.3128 23.5094 16.6374 23.6268 18.7104 22.0231C16.0898 19.4024 13.4301 16.7427 10.8095 14.122ZM20.1967 20.4585C21.4483 18.8157 21.6439 15.5301 19.4536 13.3397C17.2632 11.1494 14.0168 11.3449 12.3349 12.6357C14.9555 15.2563 17.5761 17.877 20.1967 20.4585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1302 17.4076C23.1302 21.6711 19.6882 25.1131 15.4249 25.1131C11.1615 25.1131 7.68045 21.6711 7.71956 17.4076C7.71956 13.1442 11.2006 9.70213 15.464 9.70213C19.6882 9.70213 23.1302 13.1833 23.1302 17.4076ZM10.8095 14.122C9.44055 15.7648 9.12764 19.0113 11.2398 21.2799C13.3128 23.5094 16.6374 23.6268 18.7104 22.0231C16.0898 19.4024 13.4301 16.7427 10.8095 14.122ZM20.1967 20.4585C21.4483 18.8157 21.6439 15.5301 19.4536 13.3397C17.2632 11.1494 14.0168 11.3449 12.3349 12.6357C14.9555 15.2563 17.5761 17.877 20.1967 20.4585Z",
    fill: "url(#paint2_linear_698_4835)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_698_4835",
    x1: 0.870117,
    y1: 11.3552,
    x2: 15.8084,
    y2: 11.3552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_698_4835",
    x1: 9.07125,
    y1: 17.3482,
    x2: 21.8101,
    y2: 17.3482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_698_4835",
    x1: 8.7633,
    y1: 19.8683,
    x2: 23.1074,
    y2: 13.4309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED2651"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavBlocklist);
export default __webpack_public_path__ + "static/media/sidenav_blocklist.bfc346ecca8746788f382490f76be55c.svg";
export { ForwardRef as ReactComponent };